import { FormEvent, useState } from "react";

import { CreateMailDto } from "../models/CreateMailDto.ts";
import { useMailMutation } from "../mutations/useMailMutation.ts";
import { useFormValidation } from "./useFormValidation.ts";

export const useMailCreation = () => {
  const [formData, setFormData] = useState<CreateMailDto>({
    senderEmail: "",
    receiverEmail: "",
    subject: "",
    templateCode: undefined,
    templateVariables: undefined,
    body: "",
    ccs: undefined,
    bccs: undefined
  });
  const [errors, setErrors] = useState<{
    senderEmail?: string;
    receiverEmail?: string;
  }>({});
  const { saveMailMutation } = useMailMutation();
  const { validateEmailFormat } = useFormValidation();

  const handleChange = (field: string, value: string | string[]) => {
    if (field === "senderEmail" || field === "receiverEmail") {
      if (typeof value === "string" && !validateEmailFormat(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "Invalid email format"
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: null
        }));
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value
    }));
  };
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    saveMailMutation.mutate(formData);
  };
  return {
    formData,
    handleSubmit,
    handleChange,
    errors
  };
};
